import { I18N_NAMESPACE } from "../constants/i18n"

export const onMutationSuccessFeedback = (config, setSnackbar, data, variables) => {
    if (config) {
        if (config.onSuccess) {
            config.onSuccess(data, variables)
        }

        if (config.successSnackbarMessage) {
            setSnackbar({
                label: config.successSnackbarMessage,
                severity: "success",
                anchorOrigin: {
                    horizontal: "left",
                    vertical: "bottom",
                },
                duration: config.successSnackbarDuration ?? 5000,
            })
        }
    }
    return null
}

export const onMutationErrorFeedback = (config, setSnackbar, error, t) => {
    if (config) {
        if (config.onError) {
            config.onError(error)
        }

        if (config.errorSnackbarMessage || config.showErrorMessage) {
            setSnackbar({
                label: getErrorMessage(error, config, t),
                severity: "error",
                anchorOrigin: {
                    horizontal: "left",
                    vertical: "bottom",
                },
                duration: 5000,
            })
        }
    }
    return null
}

function isHtmlString(str) {
    return typeof str === "string" && str.startsWith("<") && str.endsWith(">")
}

export function getErrorMessage(error, config, t) {
    const errorMessageFromApi = error?.response?.data || error?.message
    const apiErrorMessage = formatApiErrorMessage(error, errorMessageFromApi)
    return typeof config.errorSnackbarMessage === "string" ? config.errorSnackbarMessage
        : apiErrorMessage ?? t(I18N_NAMESPACE, "alertContext.snackbar.unknownError")
}

export function formatApiErrorMessage(error, errorMessage) {
    if (Array.isArray(errorMessage)) {
        return errorMessage.reduce((message, part, index) => {
            const formattedPart = formatApiErrorMessage(error, part)
            if (formattedPart) {
                const lastItem = index === errorMessage.length - 1
                message += `${formattedPart}${lastItem ? "" : " \n"}`
            }
            return message
        }, "")
    }

    if (typeof errorMessage === "string") {
        if (isHtmlString(errorMessage)) {
            return null
        }
        return errorMessage
    }

    if (typeof errorMessage === "object") {
        return Object.values(errorMessage).reduce((message, part, index) => {
            const formattedPart = formatApiErrorMessage(error, part)
            if (formattedPart) {
                const lastItem = index === Object.values(errorMessage).length - 1
                message += `${formattedPart}${lastItem ? "" : " \n"}`
            }
            return message
        }, "")
    }

    if (error?.response?.status) {
        return `${error?.response?.status}: ${error?.response?.statusText}`
    }

    return null
}